import { createContext } from 'react'
type Context = {
  [key: string]: any
}
export const GlobalContext = createContext<Context>({})